import Icon from '../icon'

export default {
  name: 'KTimelineItem',
  inject: ['context'],
  props: {
    type: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },
  computed: {
    dotPlacement() {
      return this.context.dotPlacement
    },
    joinLine() {
      return this.context.joinLine
    },
    style() {
      if (this.dotPlacement) {
        return {
          top: this.dotPlacement,
        }
      }
    },
  },
  methods: {
    renderDot() {
      const css = {
        'km-timeline__item-dot': true,
        [`km-timeline__item-dot--${this.type}`]: this.type,
        'km-timeline__item-dot--has-icon': this.icon,
        'km-timeline__item-dot--wave': this.wave,
      }

      const data = {
        class: css,
        ref: 'bubble',
        style: this.style,
      }

      return (
        <div
          {...data}
        >
          {this.icon
            ? <Icon name={this.icon} />
            : null
          }
          {this.renderJoinLine()}
        </div>
      )
    },
    renderLine() {
      const css = {
        'km-timeline__item-line': true,
      }

      const data = {
        class: css,
        style: this.style,
      }

      return (
        <div {...data}></div>
      )
    },
    renderJoinLine() {
      if (!this.joinLine) {
        return null
      }
      const css = {
        'km-timeline__item-join-line': true,
        'km-timeline__item-join-line--has-icon': this.icon,
      }

      const data = {
        class: css,
      }

      return (
        <div {...data}></div>
      )
    },
  },
  render() {
    const css = {
      'km-timeline__item': true,
    }

    const data = {
      class: css,
    }

    return (
      <div
        {...data}
      >
        {this.renderDot()}
        {this.renderLine()}
        <div class="km-timeline__item-content">
          {this.$slots.default}
        </div>
      </div>
    )
  },
}
